export default function normalizeError(error) {
  if (error instanceof Error) {
    const jsonString = JSON.stringify(error, ['name', 'message', 'stack']);
    return JSON.parse(jsonString);
  }

  return error || {};
}
